import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectMembershipsListItems } from "../../../../../../redux/memberships/selector";
import { memberships } from "../../../../../../redux/memberships/action";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";

const ManagementMemberships = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const membershipItems = useSelector(selectMembershipsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const [
        subColumnDefs,
        setSubColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name' },
          { field: 'IsAccountLevel', headerName: 'Account Level', cellRenderer: 'yesNoRenderer' },
          { field: 'AssociatedRoleName', headerName: 'Associated Role Name' },
          { field: 'IsAssociatedWithSubscription', headerName: 'Associated With Subscription', cellRenderer: 'yesNoRenderer' },
          { field: 'AssociatedDomainName', headerName: 'Associated Domain Name' },
          { field: 'MembershipLength', headerName: 'Membership Length' },
          { field: 'MembershipCyclePeriod', headerName: 'Membership Cycle Period' },
          { field: 'MembershipTotalCycle', headerName: 'Membership Total Cycle' },
          { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
          { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
          { field: 'ViewMoreDetails', headerName: 'ViewMore Details',isExpanded:true },
      
        ]);
        setSubColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            headerName: 'Sl',
            isSortLabel:false,
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'DomainName', headerName: 'Name' },
          { field: 'Description', headerName: 'Description' },
          { field: 'Icon', headerName: 'Icon' },
          { field: 'DisplayOrder', headerName: 'DisplayOrder' }
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      const handleDelete=(data: any)=>{
        dispatch(memberships.delete({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/memberships/delete`,
          entity: 'memberships',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
          dispatch(memberships.list({
              url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/memberships/list`,
              entity: 'memberships',
              jsonData: { "PageNumber": pageData,
              "PageSize": 10,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }  
      const fetchMemberships=()=>{

        dispatch(memberships.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/memberships/list`,
          entity: 'memberships',
          jsonData: { "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",}
      }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchMemberships()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add Memberships',
      callback: () => handleAdd(),
    }
  ];

	return (
    <>
    {membershipItems?.isLoading ? 
    <PageLoader />
: 
		<Table subColumnDefs={subColumnDefs} columnData={columnDefs} rowData={membershipItems?.result?.items} setPageData={setPageData}
    paginationData={membershipItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Memberships"  />
      
  }
  </> 
	);
  
};

export default ManagementMemberships;


